import React from 'react';

import { IGroupMember } from '../../../store/group/groupState';
import Icon from '../icon/Icon'

interface IOwnProps {
    member: IGroupMember;
    useRoundedImage?: boolean;
}

type Props = IOwnProps;

class MemberImage extends React.Component<Props, {}> {
    private hasImage = () => !!this.props.member.businessCard && !!this.props.member.businessCard.personImageUrl;

    private image = () => this.hasImage() && this.props.member.businessCard
        ? this.props.useRoundedImage
            ? <div style={{ backgroundImage: `url('${this.props.member.businessCard.personImageUrl}')` }} />
            : <img src={this.props.member.businessCard.personImageUrl} alt={this.props.member.fullName} />
        : this.props.useRoundedImage
            ? <Icon name="profile" />
            : <span className="icon"><Icon name="profile" /></span>;

    public render() {
        return <div className={'contact__image'.cAppend(!this.hasImage(), 'contact__image--anonymous').cAppend(this.props.useRoundedImage, 'contact__image--rounded')}>
            {this.image()}
        </div>;
    }
}

export default MemberImage;